import React, { ReactElement } from 'react';
import DOMPurify from 'dompurify';
import {
  Col, Heading, InsetText, Row,
} from 'idsk-react-components';
import Predpis from '../../model/Predpis';
import './predpisy.scss';
import BoxList from '../BoxList/BoxList';
import Jazyk from '../../model/Jazyk';
import BoxListItemType from '../BoxList/BoxListItemType';
import routes from '../../routing/routes';

interface Props {
  pravnePredpisy: Predpis|null|undefined
}

const Predpisy = (
  { pravnePredpisy }
: Props,
): ReactElement => {
  const mapPravnePredpisyToBoxListItem = (list: Jazyk[]):BoxListItemType[] => list.map(jazyk => ({
    id: jazyk.id,
    to: routes.jazyk.withParams(jazyk.name),
    name: jazyk.jazyk,
    iconPath: jazyk.iconPath,
  }));

  return (
    <div className="predpisy">
      <Heading
        className="page-heading"
        size="xl"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(pravnePredpisy?.nadpis || '') }}
      />
      <Row className="main">
        <Col width="two-thirds">
          {/* eslint-disable-next-line react/no-danger */}
          <span
            className="popis"
            /* eslint-disable-next-line react/no-danger */
            dangerouslySetInnerHTML={
            { __html: DOMPurify.sanitize(pravnePredpisy?.popis || '') }
}
          />
          {pravnePredpisy?.upozornenie && (
            <InsetText type="warn-info">
              <strong>
                {/* eslint-disable-next-line react/no-danger */}
                <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(pravnePredpisy?.upozornenie || '') }} />
              </strong>
            </InsetText>
          )}
        </Col>
      </Row>
      <BoxList dataList={pravnePredpisy?.jazyky && mapPravnePredpisyToBoxListItem(pravnePredpisy?.jazyky || '')} />
    </div>

  );
};

export default Predpisy;
